export class KBData {
  intent: string;
  answer: string;
}
